import { useState, useEffect, useCallback } from "react";
import { useAppSelector } from "State/hooks";
import { getOrganisationInstallSummary } from "@intelligentlilli/api-layer";
import type { Granularity } from "@intelligentlilli/api-layer";
import type { OrganisationInstallSummaryType } from "@intelligentlilli/api-layer";

export const useInstallPerformance = (
  orgId: number | undefined,
  granularity: Granularity,
  startTime: string,
  endTime: string
) => {
  const server = useAppSelector((state) => state.session.server);

  const [data, setData] = useState<OrganisationInstallSummaryType | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = useCallback(() => {
    if (!orgId || !server) return;
    setLoading(true);
    setError(false);
    getOrganisationInstallSummary(
      server,
      orgId,
      granularity,
      startTime,
      endTime,
      "web"
    )
      .then((res) => {
        if (res.ok && res.data) {
          setData(res.data);
        } else {
          console.error(
            "useInstallPerformance: request failed — body:",
            res.data
          );
          setError(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("useInstallPerformance: request threw:", err);
        setError(true);
        setLoading(false);
      });
  }, [server, orgId, granularity, startTime, endTime]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
